"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useColors = _interopRequireDefault(require("./use-colors"));

var _useEventCallback = _interopRequireDefault(require("use-event-callback"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colorsToCycle = ["red", "yellow", "orange", "magenta", "violet", "blue", "cyan", "green"];

var _default = function _default() {
  var themeColors = (0, _useColors.default)();
  return (0, _useEventCallback.default)(function (label) {
    if (!label) return themeColors.fg;
    var hashNumber = 0;

    for (var i = 0; i < label.length; i++) {
      hashNumber += label.charCodeAt(i);
    }

    return themeColors[colorsToCycle[hashNumber % colorsToCycle.length]];
  });
};

exports.default = _default;